/** Keep in sync with bedbooking_react_native/.../webViewIntegrationConfigConstants.ts */
export const BB_INTEGRATION_CONFIG_SAVED = 'BB_INTEGRATION_CONFIG_SAVED'
export const BB_INTEGRATION_CONFIG_SAVED_SCOPE = 'IntegrationConfig'
export const INTEGRATION_CONFIG_SAVED_VERSION = 1

export type IntegrationId = 'icalendar' | 'booking' | 'airbnb'
